<script setup>
import { useI18n } from "vue-i18n";
import CategoriesPreview from "./CategoriesPreview.vue";
import ProfilesPreview from "./ProfilesPreview.vue";
import ProjectsPreview from "./ProjectsPreview.vue";
import { computed } from "vue";

const settings = defineModel("settings");

const props = defineProps({
    categories: {
        type: Array,
        default: [],
    },
    profiles: {
        type: Array,
        default: [],
    },
});

const { t: __ } = useI18n();

const deleteCategory = (index) => {
    let category = settings.value.categories[index];

    if (category) {
        let id = category.id;

        // dissociate from projects
        settings.value.projects.forEach((project) => {
            if (project.category_id === id) {
                project.category_id = null;
            }
        });

        settings.value.categories.splice(index, 1);
    }
};

const deleteProfile = (index) => {
    let profile = settings.value.profiles[index];

    if (profile) {
        let id = profile.id;

        // dissociate from projects
        settings.value.projects.forEach((project) => {
            if (project.profile_id === id) {
                project.profile_id = null;
            }
        });

        settings.value.profiles.splice(index, 1);
    }
};

const deleteProject = (index) => {
    let project = settings.value.projects[index];

    if (project) {
        settings.value.projects.splice(index, 1);
    }
};

const allProfiles = computed(() => {
    let profiles = [];

    (settings.value.profiles ?? []).forEach((profile) => {
        profiles.push({ name: profile.first_name + " " + profile.last_name, id: profile.id, existing: false });
    });

    props.profiles.forEach((profile) => {
        profiles.push({ name: profile.user_first_name + " " + profile.user_last_name, id: "prf_" + profile.id, existing: true });
    });

    return profiles;
});

const allCategories = computed(() => {
    let categories = [];

    (settings.value.categories ?? []).forEach((category) => {
        categories.push({ name: category.name, id: category.id, existing: false });
    });

    props.categories.forEach((category) => {
        categories.push({ name: category.name, id: "cat_" + category.term_id, existing: true });
    });

    return categories;
});
</script>

<template>
    <div class="space-y-3">
        <CategoriesPreview
            v-if="settings.categories"
            v-model:categories="settings.categories"
            @deleteCategory="deleteCategory"
            :local-categories="categories" />
        <ProfilesPreview v-if="settings.profiles" v-model:profiles="settings.profiles" @deleteProfile="deleteProfile" :local-profiles="profiles" />
        <ProjectsPreview
            v-if="settings.projects"
            v-model:projects="settings.projects"
            @deleteProject="deleteProject"
            :categories="allCategories"
            :profiles="allProfiles" />
    </div>
</template>
